import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useAuth from "../../../../../../components/hooks/useAuth";
import Loader from "../../../../../../components/Loader";

const CampaignListOperations = ({
  setCampaignSelected,
  campaignSelected,
  setEtapaAtual,
  nextStep
}) => {
  const { getApi } = useAuth();
  const { id } = useParams();
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedAll, setSelectedAll] = useState(false);

  // Cor de fallback caso a variável global falhe
  const primaryColor = window.notifyColor || "#005c53";

  // Efeito para lidar com o ID vindo da rota
  useEffect(() => {
    // Agora processa qualquer ID presente na URL sem restrições
    if (id) {
      setCampaignSelected([id]);
      if (nextStep) {
        console.log(nextStep);
        setEtapaAtual(nextStep);
      }
    }
  }, [id, nextStep, setCampaignSelected, setEtapaAtual]);

  useEffect(() => {
    loadCampaigns();
  }, []);

  const loadCampaigns = async () => {
    setLoading(true);
    try {
      let response = await getApi("/api/v1/campaign/list", []);
      if (response && response.lista) {
        setCampaigns(response.lista);
      } else if (Array.isArray(response)) {
        setCampaigns(response);
      }
    } catch (error) {
      console.error("Erro ao carregar campanhas", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectAll = (checked) => {
    setSelectedAll(checked);
    if (checked) {
      setCampaignSelected(campaigns.map(x => x.id));
    } else {
      setCampaignSelected([]);
    }
  };

  const handleSelectCampaign = (campId) => {
    if (campaignSelected.includes(campId)) {
      setCampaignSelected(campaignSelected.filter((n) => n !== campId));
    } else {
      setCampaignSelected([...campaignSelected, campId]);
    }
  };

  // Se houver um ID, mostramos o Loader enquanto o redirecionamento automático ocorre
  if (loading || id) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: "100px" }}>
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        maxWidth: "800px",
        margin: "0 auto",
      }}
    >
      <h3 style={{ color: "#005c53", marginBottom: 8, textAlign: "center", fontSize: "24px" }}>
        Escolha as Campanhas
      </h3>
      <p style={{ color: "#666", marginBottom: 32 }}>Selecione uma ou mais campanhas para continuar</p>

      {/* Botão de Acção Principal */}
      <div style={{ position: "sticky", top: 0, background: "#fff", padding: "10px", zIndex: 10, width: "100%", display: "flex", justifyContent: "center", marginBottom: 20 }}>
        <button
          style={{
            background: campaignSelected.length > 0 ? primaryColor : "#d1d5db",
            color: "#fff",
            border: "none",
            borderRadius: "12px",
            padding: "14px 40px",
            fontWeight: "bold",
            fontSize: 16,
            cursor: campaignSelected.length > 0 ? "pointer" : "not-allowed",
            boxShadow: campaignSelected.length > 0 ? `0 4px 14px ${primaryColor}44` : "none",
            transition: "all 0.3s ease",
          }}
          onClick={() => {
            if (campaignSelected.length > 0) {
              setEtapaAtual(nextStep);
            }
          }}
          disabled={campaignSelected.length === 0}
        >
          Próxima Etapa ({campaignSelected.length})
        </button>
      </div>

      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 16,
          alignItems: "center",
        }}
      >
        {campaigns.length > 0 && (
          <div
            style={{
              width: "100%",
              maxWidth: "400px",
              display: "flex",
              alignItems: "center",
              padding: "12px 20px",
              background: "#f8fafc",
              borderRadius: "12px",
              border: "1px solid #e2e8f0",
              cursor: "pointer",
            }}
            onClick={() => handleSelectAll(!selectedAll)}
          >
            <input
              type="checkbox"
              checked={selectedAll}
              onChange={(e) => handleSelectAll(e.target.checked)}
              style={{
                accentColor: primaryColor,
                width: 22,
                height: 22,
                cursor: "pointer",
                marginRight: 15,
              }}
            />
            <span style={{ fontWeight: "600", color: "#334155" }}>Selecionar Todas</span>
          </div>
        )}

        {campaigns.length === 0 && !loading ? (
          <div style={{ padding: 40, textAlign: "center", color: "#666" }}>
            Nenhuma campanha encontrada.
          </div>
        ) : (
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
            gap: 16,
            width: "100%"
          }}>
            {campaigns.map((campaign) => (
              <div
                key={campaign.id}
                onClick={() => handleSelectCampaign(campaign.id)}
                style={{
                  background: campaignSelected.includes(campaign.id) ? "#f0fdf4" : "#fff",
                  borderRadius: 16,
                  padding: 16,
                  border: `2px solid ${campaignSelected.includes(campaign.id) ? primaryColor : "#f1f5f9"}`,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                  display: "flex",
                  alignItems: "center",
                  gap: 16,
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
              >
                <input
                  type="checkbox"
                  checked={campaignSelected.includes(campaign.id)}
                  onChange={() => { }}
                  style={{
                    accentColor: primaryColor,
                    width: 20,
                    height: 20,
                    cursor: "pointer",
                  }}
                />

                <div style={{ position: "relative" }}>
                  <img
                    src={campaign.picture_url || "https://ui-avatars.com/api/?name=" + campaign.name}
                    alt={campaign.name}
                    style={{
                      width: 50,
                      height: 50,
                      borderRadius: "14px",
                      objectFit: "cover",
                    }}
                  />
                  {campaign.alive && (
                    <span
                      style={{
                        position: "absolute",
                        top: -4,
                        right: -4,
                        width: 14,
                        height: 14,
                        borderRadius: "50%",
                        background: "#22c55e",
                        border: "2px solid #fff",
                        boxShadow: "0 0 5px rgba(34, 197, 94, 0.5)",
                      }}
                    />
                  )}
                </div>

                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: "bold", color: "#1e293b", fontSize: 16 }}>
                    {campaign.name}
                  </div>
                  <div style={{ fontSize: 12, color: "#64748b" }}>
                    ID: {campaign.id}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <style>
        {`
          @keyframes pulse {
            0% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.2); opacity: 0.7; }
            100% { transform: scale(1); opacity: 1; }
          }
        `}
      </style>
    </div>
  );
};

export default CampaignListOperations;